import {setIsTokenExpired} from '../components/Offline/service';
import {getRecentUpdates, refreshHomePage} from '../_shared/GWTBridge/invoke/priApi';
import {checkMail, generalGetFeedCounter} from '../_shared/GWTBridge/invoke/genPage';
import {isNetFormOnTop} from '../_shared/GWTBridge/invoke/netForm';
import {setSecureJWTCookie} from '../utils/cookieUtils';

const oidcMgr = (window as any).oidc_mgr;

const getAppUpdates = () => {
    getRecentUpdates();
    refreshHomePage();
    checkMail();
    generalGetFeedCounter();
};

const proceedRequest = (
    originalSend?: XMLHttpRequest['send'],
    context?: XMLHttpRequest,
    body?: Document | XMLHttpRequestBodyInit | null
) => {
    if (originalSend && context) {
        return originalSend.call(context, body);
    }
};

const signinSilent = (
    originalSend?: XMLHttpRequest['send'],
    context?: XMLHttpRequest,
    originalBody?: Document | XMLHttpRequestBodyInit | null
): Promise<void> => {
    if (!navigator?.onLine || !oidcMgr) {
        return Promise.resolve(proceedRequest(originalSend, context, originalBody));
    }

    return oidcMgr.getUser().then(user => {
        if (!user) {
            return proceedRequest(originalSend, context, originalBody);
        }

        setIsTokenExpired(user.expired);

        if (user.expired && (originalBody as any)?.includes('<s:Envelope')) {
            return oidcMgr.signinSilent().then(refreshedUser => {
                if (refreshedUser?.access_token) {
                    setSecureJWTCookie('JWT_token', `Bearer ${refreshedUser.access_token}`, 8);
                    return proceedRequest(
                        originalSend,
                        context,
                        replacePassword(originalBody, refreshedUser.access_token)
                    );
                }
                return proceedRequest(originalSend, context, originalBody);
            });
        }

        return proceedRequest(originalSend, context, originalBody);
    });
};

function replacePassword(xmlString, newPassword) {
    return xmlString.replace(/(<Password[^>]*>)([\s\S]*?)(<\/Password>)/, `$1${newPassword}$3`);
}

let lastUpdate = new Date();

const handleVisibilityChange = (isExternalLogin?: boolean) => {
    if (document.visibilityState === 'visible') {
        if (isExternalLogin) {
            signinSilent();
        }

        if (!isNetFormOnTop()) {
            const now = new Date();
            // update only if at least 3 minutes passed since last update
            if ((now.getTime() - lastUpdate.getTime()) / 60000 > 3) {
                lastUpdate = new Date();
                getAppUpdates();
            }
        }
    }
};

const verifyExternalLogin = () => {
    const token: string = (window as any).oidc_access_token;
    if (token) {
        return token.length > 0;
    } else {
        return false;
    }
};

export const enableSilentOIDCRefresh = () => {
    const isExternalLogin = verifyExternalLogin();
    const originalSend = XMLHttpRequest.prototype.send;

    // cache the original send
    (window as any)['cacheSend'] = originalSend;

    XMLHttpRequest.prototype.send = function (
        body?: Document | XMLHttpRequestBodyInit | null
    ): void {
        if (isExternalLogin) {
            try {
                // run signinSilent with context so it can call proceed internally
                signinSilent(originalSend, this, body);
            } catch (err) {
                console.error('Silent signin threw an error, proceeding anyway', err);
                proceedRequest(originalSend, this, body);
            }
        } else {
            proceedRequest(originalSend, this, body);
        }
    };

    if (isExternalLogin) {
        window.addEventListener('visibilitychange', () => {
            handleVisibilityChange(isExternalLogin);
        });
    }
};

export const clearStaleState = () => {
    const isExternalLogin = verifyExternalLogin();
    if (isExternalLogin) {
        oidcMgr?.clearStaleState();
    }
};

export const getSubject = () => {
    return oidcMgr.getUser().then(user => {
        return user?.profile?.sub || '';
    });
};
